import React, {memo, useCallback, useEffect, useRef} from 'react';
import PeopleNearYou from "@/app/features/find_players/components/people_near_you/widget";
import Input from "@/app/components/input";
import {t} from "i18next";
import {s} from "@/app/utils/s";
import LazyAssets from "@/app/utils/assets_widget";
import useAddMember from "@/app/components/add_member_page/slice";
import styles from "./styles.module.scss";
import {ThirtyText} from "@/app/components/texts";
import UserRowWidget from "@/app/components/user_row_widget";
import CircularProgressIndicator from "@/app/components/circular_progress_indicator";

interface Props {
  onSelect: (userId?: number | undefined) => void
}

const AddMemberPage: React.FC<Props> = ({onSelect}) => {
  const {searchUsers, loadMore, state} = useAddMember();
  const initialLoaded = useRef(false);

  const handleScroll = useCallback((e: React.UIEvent<HTMLElement>) => {
    const target = e.currentTarget;
    if (target.scrollTop + target.clientHeight >= target.scrollHeight - 50) {
      loadMore();
    }
  }, [loadMore]);

  useEffect(() => {
    const handleWindowScroll = () => {
      if (state.loadingMore || state.loading || state.isAll) return;
      const nearBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 200;
      if (nearBottom) {
        loadMore();
      }
    };

    window.addEventListener('scroll', handleWindowScroll);
    return () => window.removeEventListener('scroll', handleWindowScroll);
  }, [loadMore, state.isAll, state.loading, state.loadingMore]);

  // Load initial page with empty username so backend returns nearby/all users
  useEffect(() => {
    if (initialLoaded.current) return;
    initialLoaded.current = true;
    searchUsers('');
  }, [searchUsers]);
  return (
    <div className={styles.container} onScroll={handleScroll}>
      <Input
        hint={t(s.search)}
        onChange={searchUsers}
        prefixIcon={<LazyAssets.Search/>}
      />
      <div className={styles.children}>
        {state.users === undefined && state.loading && (
          <div className={styles.loaderRow}><CircularProgressIndicator isGreen/></div>
        )}
        {state.users !== undefined && state?.users?.length === 0 && <ThirtyText text={t(s.noPlayersNearYou)}/>}
        {state.users !== undefined && state?.users?.length > 0 && (
          <div className={styles.users}>
            {state.users.map((user, index) => (
              <UserRowWidget
                user={user}
                key={index}
                onClick={(user) => onSelect(user.id)}
              />
            ))}
            {state.loadingMore && (
              <div className={styles.loaderRow}>
                <CircularProgressIndicator isGreen/>
              </div>
            )}
          </div>
        )}
      </div>
    </div>

  )
};

export default memo(AddMemberPage);
